import React, { PureComponent } from "react";
import { Row, Copy, Wrapper, Icon, Spin } from "app/NativeComponents/common";

import { store } from "app/store";
import ButtonWrapper from "./ButtonWrapper";

const GhostButton = props => {
  const {
    children,
    primary,
    style,
    innerStyle,
    disabled = false,
    deleteButton = false,
    icon,
    fa_icon,
    notification = null,
    id,
    icon_right,
    fa_icon_right,
    pressedIn = false, //pressed in override from props
    loading = false,
    button_type = "normal",
    textColor = null,
    iconColor = null,
    iconStyle = null
  } = props;
  const colors = store.getState().settings.colors;

  return (
    <ButtonWrapper
      {...props}
      renderInner={({
        hovering /*actual pressed in from state of button wrapper*/
      }) => {
        const background_color = disabled
          ? colors.gray_selected_color
          : pressedIn || hovering
          ? deleteButton
            ? colors.error_color
            : primary
            ? colors.orange_color
            : colors.actionable_text_color
          : colors.card_color;

        const border_color = disabled
          ? colors.gray_selected_color
          : deleteButton
          ? colors.error_color
          : primary
          ? colors.orange_color
          : colors.actionable_text_color;

        const text_color = textColor
          ? textColor
          : disabled
          ? colors.light_text_color
          : pressedIn || hovering
          ? colors.white_text_color
          : deleteButton
          ? colors.error_color
          : primary
          ? colors.orange_color
          : colors.actionable_text_color;

        let iStyle = {
          borderRadius: 30,
          padding: 10,
          paddingLeft: 15,
          paddingRight: 15,
          backgroundColor: background_color,
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: border_color
        };

        let s = {
          borderRadius: 30,
          minWidth: 50,
          margin: 5
        };

        switch (button_type) {
          case "full":
            iStyle.padding = 15;
            s.marginRight = 10;
            s.marginLeft = 10;
            break;
          default:
            break;
        }
        return (
          <Wrapper
            style={{
              ...s,
              ...style
            }}
            id={id}
          >
            <Wrapper style={{ ...iStyle, ...innerStyle }}>
              <Wrapper>
                <Row style={{ alignItems: "center", justifyContent: "center" }}>
                  {loading &&
                  !icon &&
                  !fa_icon &&
                  !icon_right &&
                  !fa_icon_right ? (
                    <Wrapper style={{ marginRight: 5 }}>
                      <Spin
                        size="small"
                        color={text_color}
                        style={{ fontSize: 18 }}
                      />
                    </Wrapper>
                  ) : null}
                  {!!notification ? (
                    <>
                      {loading ? (
                        <Wrapper style={{ marginRight: 5 }}>
                          <Spin
                            size="small"
                            color={iconColor ? iconColor : text_color}
                            style={{ fontSize: 18 }}
                          />
                        </Wrapper>
                      ) : (
                        <Wrapper
                          style={{
                            backgroundColor: iconColor ? iconColor : text_color,
                            borderRadius: 30,
                            padding: 0,
                            paddingRight: 5,
                            paddingLeft: 5,
                            marginRight: 5,
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >
                          <Copy
                            style={{
                              color:
                                pressedIn || hovering
                                  ? background_color
                                  : colors.white_text_color,
                              fontSize: 12
                            }}
                          >
                            {notification}
                          </Copy>
                        </Wrapper>
                      )}
                    </>
                  ) : !!icon || !!fa_icon ? (
                    <>
                      {loading ? (
                        <Wrapper style={{ marginRight: 5 }}>
                          <Spin
                            size="small"
                            color={text_color}
                            style={{ fontSize: 18, ...iconStyle }}
                          />
                        </Wrapper>
                      ) : (
                        <Icon
                          size={18}
                          color={text_color}
                          icon={icon}
                          fa_icon={fa_icon}
                          style={{ marginRight: 5, ...iconStyle }}
                        />
                      )}
                    </>
                  ) : null}
                  <Copy
                    style={{
                      color: text_color,
                      textAlign: "center",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {children}
                  </Copy>

                  {!!icon_right || !!fa_icon_right ? (
                    <>
                      {loading ? (
                        <Wrapper style={{ marginLeft: 5 }}>
                          <Spin
                            size="small"
                            color={text_color}
                            style={{ fontSize: 18 }}
                          />
                        </Wrapper>
                      ) : (
                        <Icon
                          size={18}
                          color={text_color}
                          icon={icon_right}
                          fa_icon={fa_icon_right}
                          style={{ marginLeft: 5 }}
                        />
                      )}
                    </>
                  ) : null}
                </Row>
              </Wrapper>
            </Wrapper>
          </Wrapper>
        );
      }}
    />
  );
};

export { GhostButton };
